import { useMerchantDetails } from "@/api/merchant-details";
import { useMerchant } from "@/providers/MerchantProvider";

const REGION_CURRENCY: Record<string, string> = {
  US: "USD",
  UK: "GBP",
  DE: "EUR",
  FR: "EUR",
  IT: "EUR",
  ES: "EUR",
  IE: "EUR",
  JP: "JPY",
  PH: "PHP",
  TH: "THB",
  VN: "VND",
  MY: "MYR",
  ID: "IDR",
  SG: "SGD",
};

export const useCurrency = () => {
  const merchant = useMerchant();
  const { data } = useMerchantDetails(merchant);

  // If TTS enabled, we are inferring currency from TTS region
  if (data?.hasTikTokShopAuth && data?.ttsRegion) {
    return REGION_CURRENCY[data.ttsRegion] ?? "USD";
  }
  // Default to USD if no TTS region
  return "USD";
};
